/** biome-ignore-all lint/a11y/noLabelWithoutControl: <explanation> */
"use client";
import { Checkbox } from "@base-ui/react/checkbox";
import { Field } from "@base-ui/react/field";
import { Fieldset } from "@base-ui/react/fieldset";
import { Form } from "@base-ui/react/form";
import { CheckIcon } from "lucide-react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { Button } from "@/components/ui/button";
import cities from "@/store/cities.json";
import type { FormField } from "@/types/academy";
import { FormFieldType } from "@/types/academy";
import FormInput from "./form-input";
import FormSelect from "./form-select";
import FormText from "./form-text";
import FormYesNo from "./form-yesorno";

const FormBlock = ({ block }: { block: FormField }) => {
  switch (block.fieldType) {
    case FormFieldType.FullName:
      return (
        <FormInput block={{ ...block, label: block.label || "Ad Soyad" }} />
      );
    case FormFieldType.Phone:
      return (
        <FormInput block={{ ...block, label: block.label || "Telefon" }} />
      );

    case FormFieldType.City:
      return (
        <FormSelect
          block={{
            ...block,
            label: block.label || "Şehir",
            optionItems: Object.entries(cities).map((city) => ({
              id: city[0],
              label: city[1],
            })),
          }}
        />
      );
    case FormFieldType.OpenText:
      return <FormText block={block} />;
    case FormFieldType.YesOrNo:
      return (
        <FormYesNo block={{ ...block, label: block.label || "Evet/Hayır" }} />
      );
    case FormFieldType.Dropdown:
      return <FormSelect block={block} />;

    default:
      return null;
  }
};
const FormBuilder = ({
  fields,
  consent,
}: {
  fields: FormField[];
  consent: {
    consentLinkText: string;
    consentText: string;
    consentUrl: string;
    submitButtonText: string;
  };
}) => {
  const form = useForm();
  const submitHandler = () => {
    console.log(form.getValues());
  };
  return (
    <FormProvider {...form}>
      <Form
        className="w-2/3 flex flex-col gap-2"
        onSubmit={form.handleSubmit(submitHandler)}
      >
        {fields
          .sort((a, b) => a.displayOrder - b.displayOrder)
          .map((field) => (
            <FormBlock block={field} key={field.id} />
          ))}
        <Controller
          control={form.control}
          defaultValue={false}
          name="consent"
          render={({ field, fieldState }) => {
            return (
              <Field.Root
                dirty={fieldState.isDirty}
                invalid={fieldState.invalid}
                touched={fieldState.isTouched}
              >
                <Fieldset.Root>
                  <label className="flex items-center gap-2 text-base text-gray-900 font-normal">
                    <Checkbox.Root
                      className="flex size-5 shrink-0 items-center justify-center rounded-xs focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 data-[checked]:bg-gray-900 data-[unchecked]:border data-[unchecked]:border-gray-300"
                      defaultChecked={false}
                      onBlur={field.onBlur}
                      onCheckedChange={field.onChange}
                      ref={field.ref}
                      value={field.value}
                    >
                      <Checkbox.Indicator className="flex text-gray-50 data-[unchecked]:hidden">
                        <CheckIcon className="size-3" />
                      </Checkbox.Indicator>
                    </Checkbox.Root>
                    {consent.consentText}
                  </label>
                  <Field.Error
                    className="text-sm text-red-600 font-medium"
                    match={!!fieldState.error}
                  >
                    Bu alan zorunludur
                  </Field.Error>
                </Fieldset.Root>
              </Field.Root>
            );
          }}
          rules={{ required: true }}
        />
        <Button className="w-fit" type="submit">
          {consent.submitButtonText || "Başvur"}
        </Button>
      </Form>
    </FormProvider>
  );
};

export default FormBuilder;
